import { render } from "./SystemRoleForm.vue?vue&type=template&id=6ec566db&scoped=true&ts=true"
import script from "./SystemRoleForm.vue?vue&type=script&lang=ts"
export * from "./SystemRoleForm.vue?vue&type=script&lang=ts"

import "./SystemRoleForm.vue?vue&type=style&index=0&id=6ec566db&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec566db"]])

export default __exports__